import { SessionTypeEnum } from "@api/enums/Session/SessionTypeEnum";
import { dateInOriginalOffset } from "@common/dateTimeHelper";
import { getDates } from "@share/program/helpers/dates";
import { EventInterface } from "@share/program/types/EventInterface";
import { DateTime } from "luxon";

export interface FilteringParams {
    sessionTypes: SessionTypeEnum[];
    date: DateTime | null;
    timeZone: string;
    tagsIds?: string[];
    keyword: string;
}

const compareDates = (begin: DateTime, dayStart: DateTime, dayEnd: DateTime) => {
    return begin >= dayStart && begin <= dayEnd;
}

export const getFiltered = ({ sessionTypes, date, timeZone, tagsIds, keyword }: FilteringParams, sessions: EventInterface[]) => {

    /**
     * filtering by date
     */
    if (date) {
        let { dayStart, dayEnd } = getDates(date);
        const offset = parseInt(timeZone);

        if(!isNaN(offset)) {
            dayStart = dateInOriginalOffset(dayStart, offset, true);
            dayEnd = dateInOriginalOffset(dayEnd, offset, true);
        }

        sessions = sessions.filter(session => compareDates(dateInOriginalOffset(session.beginAt, offset), dayStart, dayEnd));
    }

    /**
     * filtering by tags
     */
    if (tagsIds?.length) {
        sessions = sessions.filter(session => tagsIds.some(tagId => session.tagsIds?.includes(tagId)))
    }

    /**
     * filtering by session types
     */
    if (sessionTypes.length) {
        sessions = sessions.filter((session) => sessionTypes.includes(session.type))
    }

    /**
     * filtering by keyword
     */
    if (keyword.length) {
        sessions = sessions.filter((session) => (session.title as string).toLocaleUpperCase().includes(keyword.toLocaleUpperCase()))
    }

    return sessions;
}